<template>
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" :class="cls" :style="innerStyle" :stroke-width="strokeWidth" :stroke-linecap="strokeLinecap" :stroke-linejoin="strokeLinejoin" @click="onClick"><path d="M13.5 10c.278 0 .55.03.81.086l.122.432c.072.26.25.48.495.616.245.135.536.172.81.104l.452-.115c.372.384.65.841.811 1.34l-.33.317a.989.989 0 0 0 0 1.44l.33.317a3.463 3.463 0 0 1-.81 1.34l-.453-.115a1.119 1.119 0 0 0-.81.104 1.02 1.02 0 0 0-.495.616l-.122.432a3.847 3.847 0 0 1-1.62 0l-.122-.432a1.02 1.02 0 0 0-.495-.616 1.12 1.12 0 0 0-.81-.104l-.452.114A3.462 3.462 0 0 1 10 14.538l.33-.318a.989.989 0 0 0 0-1.44l-.33-.317c.162-.498.439-.956.81-1.34l.453.115c.274.068.565.03.81-.104a1.02 1.02 0 0 0 .495-.616l.122-.432c.266-.057.538-.086.81-.086Zm0 2.042c-.843 0-1.526.653-1.526 1.458 0 .805.683 1.458 1.526 1.458s1.526-.653 1.526-1.458c0-.805-.683-1.458-1.526-1.458ZM9.674 10.148l-.04.05a5.403 5.403 0 0 0-.908 1.642l-.053.164-.025.09-.019.09c-.088.482.048.98.371 1.35l.063.068L9 13.67a1.6 1.6 0 0 0-.327 1.526c.202.657.527 1.27.958 1.804h-5.7c-1.615 0-2.835-1.312-2.924-2.925-.115-2.071 1.258-3.408 2.923-3.704 1.566-.278 3.83-.267 5.744-.223ZM9.002 1A4 4 0 0 1 13 5a4 4 0 0 1-3.998 4 4 4 0 0 1-3.998-4 4 4 0 0 1 3.998-4Z" fill="currentColor" stroke="transparent"></path></svg>
</template>

<script lang="ts">
import { defineComponent, computed, CSSProperties } from 'vue';
import { getPrefixCls } from '../../_utils/global-config';
import { isNumber } from '../../_utils/is';

export default defineComponent({
  name: 'IconBusinessCandidateFill',
  props: {
    size: {
      type: [Number, String],
    },
    strokeWidth: {
      type: Number,
      default: 4
    },
    strokeLinecap: {
      type: String,
      default: 'butt',
      validator: (value: any) => {
        return ['butt', 'round', 'square'].includes(value);
      }
    },
    strokeLinejoin: {
      type: String,
      default: 'miter',
      validator: (value: any) => {
        return ['arcs', 'bevel', 'miter', 'miter-clip', 'round'].includes(value);
      }
    },
    rotate: Number,
    spin: Boolean
  },
  emits: {
    click: (ev: MouseEvent) => true,
  },
  setup(props, { emit }) {
    const prefixCls = getPrefixCls('icon');
    const cls = computed(() => [prefixCls, `${prefixCls}-business-candidate-fill`, { [`${prefixCls}-spin`]: props.spin }]);
    const innerStyle = computed(() => {
      const styles: CSSProperties = {};
      if (props.size) {
        styles.fontSize = isNumber(props.size) ? `${props.size}px` : props.size;
      }
      if (props.rotate) {
        styles.transform = `rotate(${props.rotate}deg)`;
      }
      return styles;
    });
    const onClick = (ev: MouseEvent) => {
      emit('click', ev);
    };

    return {
      cls,
      innerStyle,
      onClick,
    };
  }
});
</script>
